import React, { useState } from "react";
import {
  Button,
  Box,
  TextField,
  Switch,
  FormControlLabel,
  Autocomplete,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import {
  verifyCode,
  setUserPIN,
  setUserPassword,
} from "../../util/API/verifycode";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CheckMark from "../../images/ic_round-check.svg";
import { countryAreaCode } from "../../constants/countrylist";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import { sendOTP, verifyOTP } from "../../util/http";

function VerifyCodeForm({ toggleVerify, newDevice, userid, username, handleLogin, deviceToken, deviceAuthCredentials, showSwitch=true, method }) {
  const [step, setStep] = useState(1);
  // const [method, setMethod] = useState("email");
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [countryCode, setCountryCode] = useState({
    value: "na",
    label: "Please select an area code",
    key: "na",
  });
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [pin, setPin] = useState({
    pin: ["", "", "", ""],
    confirmpin: ["", "", "", ""],
  });
  const [visible, setVisible] = useState({
    password: false,
    confirmPassword: false,
    pin: false,
    confirmpin: false,
  });
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "error",
    header: "",
    message: "",
  });
  const [showVerifcationInput, setShowVerificationInput] = useState(!newDevice);
  const [showInputField, setShowInputField] = useState(!newDevice);

  const handleNext = async () => {
    if (!deviceToken) {
      deviceToken = localStorage.getItem('deviceID');
    }
    if (newDevice) {
      const response = await verifyOTP(userid, deviceToken, verificationCode);
      if (response.Status !== "1") {
        console.log("no verification");
        setAlert({
          showAlert: true,
          severity: "error",
          header: "Error",
          message: "Invalid Code"
        });
        return;
      }
      handleLogin();
      return;
    }

    if (step === 1) {
      console.log("step1======",verificationCode);
      const response = await verifyCode(countryCode?.value?.replace("+", ""), method, email, mobile, verificationCode);
      console.log(response?.payload?.body?.Vuser?.profilestatus !== "3")
      console.log("handleNext_response======",response);
      if (
        response && 
        response?.payload?.header?.callStatus === "1" && 
        (response?.payload?.body?.Vuser?.profilestatus !== "3")
      ) { 
        setStep((prevStep) => prevStep + 1);
      } else if (response?.Status === "2" && response?.errorCode === "UNAUTHORIZED") {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "error",
          header: "Error",
          message: "Unauthorized Access",
        });
      } else {
        if(response?.msg && response?.msg !== "") {
          setAlert({
            ...alert,
            showAlert: true,
            severity: "error",
            header: "Error",
            message: response?.msg,
          });
        } else {
          setAlert({
            ...alert,
            showAlert: true,
            severity: "error",
            header: "Error",
            message: "This account has already been verified. Please login to the account or reset your password if you forgot the password.",
          });
        }
      }
    } else if (step === 2) {
      const response = await setUserPassword(password, email);
      if (response?.Status === "1") {
        setStep((prevStep) => prevStep + 1);
      } else {
        console.log(response);
      }
    }
  };
  const handleBack = () => setStep((prevStep) => prevStep - 1);

  const handleSubmit = async () => {
    if (pin.pin.join("") === pin.confirmpin.join("")) {
      const pinResponse = await setUserPIN(pin.pin.join(""), email);
      if (pinResponse?.callStatus === "1") {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "success",
          header: "Success",
          message: "PIN changed successfully",
        });
      } else {
        console.error("Error resetting PIN", pinResponse);
      }
    }
  };

  const toggleVisibility = (key) => {
    setVisible((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handlePINChange = (value, index, key) => {
    if (isNaN(value)) return; // Allow only numeric input
    setPin((prev) => {
      const updatedPin = { ...prev };
      const updatedArray = [...updatedPin[key]]; 
      updatedArray[index] = value; 
      updatedPin[key] = updatedArray; 
      return updatedPin;
    });

    // Move focus to the next input box
    if (value && index < pin[key].length - 1) {
      document.getElementById(`${key}-input-${index + 1}`).focus();
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && pin[index] === "" && index > 0) {
      document.getElementById(`pin-input-${index - 1}`).focus();
    }
  };

  const renderPinFields = (key, label) => (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 1, marginBottom: 2 }}
    >
      <Typography
        variant="caption text"
        sx={{ width: "80px", fontSize: "10px", color: "grey", font: "Nunito" }}
      >
        {label}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {pin[key].map((digit, index) => (
          <TextField
            key={index}
            id={`${key}-input-${index}`}
            value={digit}
            onChange={(e) => handlePINChange(e.target.value, index, key)}
            onKeyDown={(e) => handleBackspace(e, index)}
            inputProps={{
              maxLength: 1,
              style: {
                textAlign: "center",
                fontSize: "20px",
                padding: "10px",
              },
            }}
            type={visible[key] ? "text" : "password"}
            variant="outlined"
            sx={{
              width: "50px",
              height: "50px",
              "& .MuiOutlinedInput-root": {
                padding: 0,
              },
            }}
          />
        ))}
        <IconButton onClick={() => toggleVisibility(key)}>
          {visible[key] ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </Box>
    </Box>
  );

  const handleSendCode = async() => {
    const otpMethod = username.includes("@") ? method : "mobile";
    const response = await sendOTP(userid, username, otpMethod, deviceAuthCredentials);
    if (response.Status !== "1") {

    }
    setShowVerificationInput(true);
    console.log(response);
  }

  return (
    <>
    {alert.severity === "error" &&
        <CustomAlert
          severity={alert.severity}
          show={alert.showAlert}
          header={alert.header}
          message={alert.message}
          onClick={() => {
            setAlert((prevDetails) => ({ ...prevDetails, showAlert: false }))
          }}
          autoclose={alert.severity === "error" ? false : true}
        />
      }
      {alert.showAlert && alert.severity === "success"
          ?
          <Box className="login-label d-flex gap-2" sx={{ flexDirection:"column" }}>
              <Box>
                  <Box>Your password and pin have been successfully reset.</Box>
                  <img src={CheckMark} loading="lazy" />
              </Box>

              <Box className="sign-in-here-text pointer" onClick={toggleVerify}>
                  Sign-In Here
              </Box>
          </Box>
          :
          <Box>
            <Box className="login-label" sx={{ mb: 2 }}>
              {newDevice ? "Register new device" : ""}
              {step === 1 && !newDevice && "Verify Account"}
              {step === 2 && !newDevice && "Create New Password"}
              {step === 3 && !newDevice && "Create New PIN"}
            </Box>

            <Box className="reset-email-account">{username}</Box>


            {step === 1 && (
              <Box>
                {/* {showSwitch &&
                <FormControlLabel
                  control={
                    <Switch
                      checked={method === "mobile"}
                      onChange={(e) =>
                        setMethod(e.target.checked ? "mobile" : "email")
                      }
                    />
                  }
                  label={method === "email" ? "Email" : "Mobile"}
                  sx={{ mb: 2 }}
                />} */}
                {newDevice &&                   
                  <Button
                    className="send-password-button"
                    onClick={() => handleSendCode()}
                    sx={{
                      borderRadius: "50px",
                      background: "#F9C801",
                      color: "white",
                      border: "none",
                      padding: "9px 18px",
                      bottom: "5px",
                      "&:hover": {
                        backgroundColor: "#FAD43A", // Slightly lighter shade on hover
                      },
                    }}
                  >
                    Send OTP Code
                  </Button>}
                {method === "email" ? (
                  showInputField && <TextField
                    fullWidth
                    label="Email/Username"
                    // placeholder="Email/Username"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{ mb: 2 }}
                  /> 
                ) : (
                  showInputField && 
                  <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                    <Autocomplete
                      options={countryAreaCode}
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Country Code" />
                      )}
                      value={countryCode}
                      onChange={(e, value) => setCountryCode(value)}
                      isOptionEqualToValue={(option, value) => option.value === value.value} 
                      sx={{width: "400px"}}
                    />
                    <TextField
                      fullWidth
                      label="Mobile Number"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                    />
                  </Box>
                )}
              {showVerifcationInput &&
                <TextField
                  fullWidth
                  label={newDevice ? "OTP Code" : "Verification Code"}
                  // placeholder="OTP Code"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                />
              }

              </Box>
            )}

            {step === 2 && (
              <Box>
                <TextField
                  fullWidth
                  label="Enter New Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type={visible.password ? "text" : "password"}
                  sx={{ mb: 2 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            setVisible({ ...visible, password: !visible.password })
                          }
                        >
                          {visible.password ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  fullWidth
                  label="Re-enter New Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  type={visible.confirmpassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            setVisible({
                              ...visible,
                              confirmpassword: !visible.confirmpassword,
                            })
                          }
                        >
                          {visible.confirmpassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            )}

            {step === 3 && (
              <Box>
                {renderPinFields("pin", "New PIN")}
                {renderPinFields("confirmpin", "Retype PIN")}
              </Box>
            )}

            <Box className="login-button-container" sx={{ mt: 3 }}>
              {step < 2 || step === 3 ? (
                <Box className="sign-in-here-text pointer" onClick={toggleVerify}>
                  Back to Sign-In
                </Box>
              ) : (
                <Box className="sign-in-here-text pointer" onClick={handleBack}>
                  Back to Sign-In
                </Box>
              )}
              <Box></Box>
              <Box>
                {newDevice && showVerifcationInput && step === 1 ?
                (
                  <Button
                    className="send-password-button"
                    onClick={() => handleNext()}
                    sx={{
                      borderRadius: "50px",
                      background: "#F9C801",
                      color: "white",
                      border: "none",
                      padding: "9px 18px",
                      "&:hover": {
                        backgroundColor: "#FAD43A",
                      },
                    }}
                  >
                    Verify
                  </Button>
                ) 
                : step === 1 && newDevice ? null 
                : step === 1 && !newDevice ? (
                  <Button
                    className="send-password-button"
                    onClick={() => handleNext()}
                    sx={{
                      borderRadius: "50px",
                      background: "#F9C801",
                      color: "white",
                      border: "none",
                      padding: "9px 18px",
                      "&:hover": {
                        backgroundColor: "#FAD43A", // Slightly lighter shade on hover
                      },
                    }}
                  >
                    Verify
                  </Button>
                ) 
                :
                step < 3 ? (
                  <Button
                    className="send-password-button"
                    onClick={() => handleNext()}
                    sx={{
                      borderRadius: "50px",
                      background: "#F9C801",
                      color: "white",
                      border: "none",
                      padding: "9px 18px",
                      "&:hover": {
                        backgroundColor: "#FAD43A", // Slightly lighter shade on hover
                      },
                    }}
                  >
                    Next
                  </Button>
                )
                :
                (
                  <Button
                    className="send-password-button"
                    onClick={() => handleSubmit()}
                    sx={{
                      borderRadius: "50px",
                      background: "#F9C801",
                      color: "white",
                      border: "none",
                      padding: "9px 18px",
                      "&:hover": {
                        backgroundColor: "#FAD43A",
                      },
                    }}
                  >
                    Submit
                  </Button>
                )
              }
            </Box>
          </Box>
        </Box>
      }
    </>
  );
}

export default VerifyCodeForm;
